import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthUser } from '../../../helpers/types';
import { PortalState } from './types';

export const initialState: PortalState = {
  user: null,
  isAuthenticated: false,
  bootstrapping: true,
};

export const portalSlice = createSlice({
  name: 'portal',
  initialState,
  reducers: {
    bootstrapRequest(state) {
      state.bootstrapping = true;
    },
    sessionEstablished(state, action: PayloadAction<AuthUser>) {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.bootstrapping = false;
    },
    sessionCleared(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.bootstrapping = false;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.bootstrapping = false;
    },
  },
});

export const { actions: portalActions } = portalSlice;

export const usePortalSlice = () => ({ actions: portalSlice.actions });
